<template>
    <div class="main">
        <div v-if="alreadyCreatedBeneficiaries">
            <div class="table is-fullwidth is-striped">
                <BeneficiaryResult v-for="beneficiary in alreadyCreatedBeneficiaries" :key="beneficiary.id" :id="beneficiary.id"
                    :isBeneficiaryActive="beneficiary.active" :nric="beneficiary.nric" :beneficiaryName="beneficiary.full_name"
                    :selfCollection="beneficiary.self_collection" :drivingDelivery="beneficiary.driving_delivery"
                    :unit="beneficiary.unit" :block="beneficiary.block" :street="beneficiary.street">
                </BeneficiaryResult>
            </div>
        </div>
        <div v-if="newBeneficiaryID == 0" class="align-center block">
            <button @click="createBeneficiary" class="button is-info is-rounded"
                :class="[isLoading ? 'is-loading' : '']">Create a new beneficiary</button>
        </div>
        <div v-else class="notification is-success block align-center">
            <p>A new beneficiary is created with ID: {{ newBeneficiaryID }}</p>
            <br />
            <router-link :to="editLink">
                <button class="button is-info is-rounded">Update details</button>
            </router-link>
        </div>
        <div v-if="!!error" class="notification is-danger is-light">
            <p>{{ error }}</p>
        </div>
    </div>
</template>

<script>
import BeneficiaryResult from './BeneficiaryResult.vue';

export default {
    data() {
        return {
            isLoading: false,
            error: null,
            newBeneficiaryID: 0
        }
    },
    components: {
        BeneficiaryResult,
    },
    created() {
        this.loadCreatedBeneficiaries();
    },
    methods: {
        async loadCreatedBeneficiaries() {
            this.isLoading = true;
            this.error = null;
            try {
                await this.$store.dispatch('beneficiary/getAlreadyCreatedBeneficiaries');
            } catch (error) {
                this.error = error.message || 'Something went wrong!';
            }
            this.isLoading = false;
        },

        async createBeneficiary() {
            this.isLoading = true;
            this.error = null;
            try {
                this.newBeneficiaryID = await this.$store.dispatch('beneficiary/createBeneficiary');
            } catch (error) {
                this.error = error.message || 'Something went wrong!';
            }
            this.isLoading = false;
        }
    },
    computed: {
        editLink() {
            return '/beneficiary/' + this.newBeneficiaryID + '/update';
        },
        alreadyCreatedBeneficiaries() {
            return this.$store.getters['beneficiary/getCreatedBeneficiaries'];
        }
    }
}
</script>